import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { baseHttpRequestOptions, userMessageErrorHandler } from '../services.utils';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Report, Contact } from '@app/core/models/contact/contact.model';
import { FeedbackDialogComponent } from '@app/theme/feedback-dialog/feedback-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  sharedProtocol;

  constructor(private readonly httpClient: HttpClient, public dialog: MatDialog) {}

  sendReportFile(payload): Observable<any> {
    return this.httpClient
      .post<any>(
        environment.apiURL + '/contact/sendfile',
        payload,
        baseHttpRequestOptions
      )
      .pipe(
        map((response: any) => {
          return response.data;
        })
      );
  }

  sendReportAccident(report: Report) {
    return this.httpClient
      .post<any>(`${environment.apiURL}/contact/casualty`, report, baseHttpRequestOptions)
      .pipe(
        map((data: any) => {
          this.sharedProtocol = data.data.protocol;
          return data;
        }),
        catchError((response) => {
          const message =
            userMessageErrorHandler(response) ||
            'Ocorreu um problema no envio do comunicado. Por favor, verifique os dados e teste novamente.';
          this.openFeedbackDialog('error', message);
          return throwError(message);
        })
      );
  }

  sendContact(contact: Contact) {
    return this.httpClient
      .post<any>(
        `${environment.apiURL}/contact/contact_us`,
        contact,
        baseHttpRequestOptions
      )
      .pipe(
        map((data: any) => {
          this.sharedProtocol = data.data.protocol;
          return data;
        }),
        catchError((response) => {
          const message = userMessageErrorHandler(response) || 'Erro ao enviar contato';
          this.openFeedbackDialog('error', message);
          return throwError(message);
        })
      );
  }

  public getSolicitations(params) {
    return this.httpClient
      .get(`${environment.apiURL}/contact/trackingsolicitations`, { params })
      .pipe(
        map((response: any) => {
          response.data.map((item) => {
            if (item.situation === 'AGUARDANDO JURIDICO') {
              item.situation = 'AGUARDANDO_JURIDICO';
            }
          });

          return response.data;
        }),
        catchError((response) => {
          const message = userMessageErrorHandler(response) || 'Filtro inválido!';
          this.openFeedbackDialog('error', message);
          return throwError(message);
        })
      );
  }

  openFeedbackDialog(color, message) {
    this.openDialog(FeedbackDialogComponent, {
      data: {
        color: color,
        message: message,
      },
    });
  }

  openDialog(dialogComponent, data = {}) {
    return this.dialog.open(dialogComponent, {
      data,
      panelClass: 'feedback-modalbox',
      disableClose: true,
    });
  }
}
